import { SET_SHOW_ART_WALL_CLOSE_MODAL } from '../const';

export default (showArtWallCloseModal) => {
  return {
    type: SET_SHOW_ART_WALL_CLOSE_MODAL,
    showArtWallCloseModal: showArtWallCloseModal
  }
};
